import type { components } from '@fluencelabs/vodopad-admin-api'
import { useCustom } from '@refinedev/core'
import { Typography } from 'antd'
import { Link } from 'react-router-dom'

import { MONO_STYLE } from '@/components/common/MonoId'
import { VODOPAD_ENDPOINT } from '@/constants/constants'
import { useUsersCache } from '@/hooks/useUsersByIds'

type AdminUserDto = components['schemas']['AdminUserDto']

interface Props {
  userId: string
  /** Known email; skips the lookup. */
  email?: string | null
}

export function UserEmailLink({ userId, email: known }: Props) {
  const cached = useUsersCache()
  const hasProvider = cached !== null

  const userQuery = useCustom<AdminUserDto>({
    url: `${VODOPAD_ENDPOINT}/v1/admin/users/${userId}`,
    method: 'get',
    queryOptions: {
      enabled: Boolean(userId) && !hasProvider && !known,
      staleTime: 5 * 60 * 1000,
    },
  })

  const looked = hasProvider
    ? cached[userId]?.email
    : (userQuery.query.data?.data as AdminUserDto | undefined)?.email
  const email = known ?? looked

  return (
    <Link to={`/users/${userId}`} onClick={(e) => e.stopPropagation()}>
      <Typography.Text
        copyable={{ text: email ?? userId }}
        ellipsis={email ? { tooltip: email } : undefined}
        style={{
          maxWidth: '100%',
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textUnderlineOffset: 4,
          ...(email ? {} : MONO_STYLE),
        }}
      >
        {email ?? `${userId.slice(0, 8)}...`}
      </Typography.Text>
    </Link>
  )
}
